(() => {
  const STYLE_ID = "force-zero-radius";
  const CSS = "*:not(.account-button__avatar):not(.account-button--shop-customer):not(.account-button__avatar *):not(.account-button--shop-customer *) { border-radius: 0 !important; }";

  const inject = (root) => {
    if (!root || root.querySelector(`style[data-id=\"${STYLE_ID}\"]`)) return;
    const style = document.createElement("style");
    style.setAttribute("data-id", STYLE_ID);
    style.textContent = CSS;
    root.appendChild(style);
  };

  const scanOpenShadowRoots = (startRoot) => {
    startRoot.querySelectorAll("*").forEach((el) => {
      if (!el.shadowRoot) return;
      inject(el.shadowRoot);
      scanOpenShadowRoots(el.shadowRoot);
    });
  };

  const scanInsideShopifyAccount = () => {
    const account = document.querySelector("shopify-account");
    if (!account) return;

    if (account.shadowRoot) {
      inject(account.shadowRoot);
      scanOpenShadowRoots(account.shadowRoot);
    }

    account.querySelectorAll("*").forEach((el) => {
      if (!el.shadowRoot) return;
      inject(el.shadowRoot);
      scanOpenShadowRoots(el.shadowRoot);
    });
  };

  const apply = () => {
    scanInsideShopifyAccount();
  };

  const run = () => {
    apply();
    new MutationObserver(apply).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
})();
